export const loadResizeObserverPolyfill = async (): Promise<void> => {
    if (!window.ResizeObserver) {
        // Loads polyfill asynchronously, only if required.
        const module = await import('@juggle/resize-observer');
        window.ResizeObserver = module.ResizeObserver;
    }
};
